





































helpers = require('../../../helpers.coffee')

view_model = {
  props: ['task', 'options', 'origem']

  data: ->
    current_user: Session.current_user
    element_options:
      show_date: false
      show_contact: true
      show_comment: true
      icon_position: 'text' # 'item' available
      padding: 'sm' # 'lg' available

  computed:
    interaction_total_delivery: ->
      if @task.contact.interactions_with_current_flow.total_delivery == null then '-' else @task.contact.interactions_with_current_flow.total_delivery

    interaction_total_open: ->
      if @task.contact.interactions_with_current_flow.total_open == null then '-' else @task.contact.interactions_with_current_flow.total_open

  methods:
    removeTask: ->
      event.originalEventName = 'removing'
      @$emit 'removing', { event, @task }

  created: ->
    EventsBus.$on 'voip-call-complete', @registerVoipCall
    @tasks_resources = new TasksResource
    @mergeDefaultOptions()

}

exports.default = helpers.vue_include(view_model, helpers.manual_tasks.list_item_wrapper, helpers.form, helpers.filters)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/ozzy_tasks/list_item.vue